import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function ProductPage() {
 return (
  <StaticPageLayout title='Product Overview'>
   <div className='space-y-12'>
    <section>
     <h2 className='text-2xl font-bold font-mono border-l-4 border-primary pl-4 mb-6'>
      THE CORE ENGINE
     </h2>
     <p className='text-lg text-muted-foreground'>
      MOCK.SYSTEM is built on an proprietary evaluation engine that mimics the
      rigor of FAANG-level interviews. Unlike standard chatbots, our system
      maintains context, challenges assumptions, and evaluates optimal vs.
      suboptimal solutions.
     </p>
    </section>

    <div className='grid md:grid-cols-2 gap-8'>
     <div className='bg-muted/5 p-6 border border-border'>
      <h3 className='font-mono font-bold text-primary mb-2'>
       &gt; ADAPTIVE_DIFFICULTY
      </h3>
      <p>
       The system detects your skill level in real-time and adjusts the
       complexity of follow-up questions.
      </p>
     </div>
     <div className='bg-muted/5 p-6 border border-border'>
      <h3 className='font-mono font-bold text-primary mb-2'>
       &gt; MULTI_MODAL
      </h3>
      <p>
       Support for Voice-to-Voice, Code Execution, and Whiteboarding sessions.
      </p>
     </div>
    </div>
   </div>
  </StaticPageLayout>
 );
}
